/* Functional gallery invitation. Contact details never go into analytics or a public lookup endpoint.
   The fragment contains both key and ciphertext: possession of the full link permits prefill.
   Encryption protects accidental query/referrer logging, not access by a holder of this link. */
(function () {
  'use strict';
  if (window.__nhlGalleryInvite) return;
  window.__nhlGalleryInvite = true;
  var idPattern = /^NHL-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var ttl = 90 * 86400000;
  var urlKey = 'nhl:gallery:invite-url:v1:';
  var contactKey = 'nhl:gallery:contact:v1:';
  var endpoint = location.origin + '/pages/private-gallery';
  var forms = ['commission-form', 'contact-band-form'];

  function encode(bytes) { return btoa(String.fromCharCode.apply(null, new Uint8Array(bytes))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function decode(text) { return Uint8Array.from(atob(text.replace(/-/g, '+').replace(/_/g, '/')), function (c) { return c.charCodeAt(0); }); }
  function valid(data, id) {
    return data && data.v === 1 && typeof data.id === 'string' && data.id.toLowerCase() === id.toLowerCase() && idPattern.test(data.id) &&
      typeof data.name === 'string' && data.name.trim().length > 0 && data.name.length <= 150 &&
      typeof data.email === 'string' && data.email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email) &&
      Number.isFinite(data.at) && Date.now() >= data.at - 60000 && Date.now() - data.at <= ttl;
  }
  async function make(id, name, email) {
    var data = { v: 1, id: id, name: name.trim(), email: email.trim(), at: Date.now() };
    var base = endpoint + '?gallery_ref=' + encodeURIComponent(id);
    if (!valid(data, id) || !window.crypto || !window.crypto.subtle) return base;
    var keyBytes = window.crypto.getRandomValues(new Uint8Array(32));
    var iv = window.crypto.getRandomValues(new Uint8Array(12));
    var key = await window.crypto.subtle.importKey('raw', keyBytes, 'AES-GCM', false, ['encrypt']);
    var encrypted = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv, additionalData: new TextEncoder().encode(id.toLowerCase()) }, key, new TextEncoder().encode(JSON.stringify(data)));
    return base + '#gallery_invite=v1.' + encode(keyBytes) + '.' + encode(iv) + '.' + encode(encrypted);
  }
  function stamp(form, link) {
    var field = form.querySelector('input[name="contact[Private gallery invite link]"]');
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[Private gallery invite link]'; field.setAttribute('data-clarity-mask', 'True'); form.appendChild(field); }
    field.value = link;
    if (form.__nhlInquiryId && idPattern.test(form.__nhlInquiryId)) {
      try { sessionStorage.setItem(urlKey + form.__nhlInquiryId.toLowerCase(), JSON.stringify({ url: link, at: Date.now() })); } catch (_) {}
    }
  }
  window.nhlGalleryInviteURL = function (id) {
    if (!idPattern.test(id || '')) return '';
    var base = endpoint + '?gallery_ref=' + encodeURIComponent(id);
    try {
      var saved = JSON.parse(sessionStorage.getItem(urlKey + id.toLowerCase()) || 'null');
      if (saved && Date.now() >= saved.at && Date.now() - saved.at <= ttl && saved.url.indexOf(base) === 0) return saved.url;
    } catch (_) {}
    return base;
  };
  function prepare(form) {
    if (!form.__nhlInquiryId && window.crypto && window.crypto.randomUUID) form.__nhlInquiryId = 'NHL-' + window.crypto.randomUUID();
    if (!idPattern.test(form.__nhlInquiryId || '')) return;
    var name = form.querySelector('[name="contact[name]"]'), email = form.querySelector('[name="contact[email]"]');
    var pair = JSON.stringify([name && name.value || '', email && email.value || '']);
    if (pair === form.__nhlInvitePair && form.__nhlInvitePromise) return form.__nhlInvitePromise;
    form.__nhlInvitePair = pair;
    stamp(form, endpoint + '?gallery_ref=' + encodeURIComponent(form.__nhlInquiryId));
    form.__nhlInvitePromise = make(form.__nhlInquiryId, name && name.value || '', email && email.value || '').then(function (link) {
      // Slow encryption of an earlier edit must never overwrite the latest contact.
      if (form.__nhlInvitePair === pair) stamp(form, link);
    }).catch(function () { /* ID-only link and manual contact entry remain usable. */ });
    return form.__nhlInvitePromise;
  }
  function apply(data) {
    var form = document.getElementById('private-gallery-shortlist');
    if (!form) return;
    [['name', data.name], ['email', data.email]].forEach(function (pair) {
      var input = form.querySelector('[name="contact[' + pair[0] + ']"]');
      if (input && !input.value && !input.__nhlEdited) { input.setAttribute('data-clarity-mask', 'True'); input.value = pair[1]; }
    });
    var status = form.querySelector('[data-shortlist-prefill]');
    if (status) status.textContent = 'Contact details added from your enquiry. Check or edit them before sending.';
    document.dispatchEvent(new CustomEvent('nhlGalleryPrefilled'));
  }
  async function prefill() {
    var id = new URLSearchParams(location.search).get('gallery_ref') || '';
    // Confirmed Shopify render may have lost the query, but its current submission carries the ID.
    if (!idPattern.test(id)) return;
    var form = document.getElementById('private-gallery-shortlist');
    if (form) form.addEventListener('input', function (e) { e.target.__nhlEdited = true; });
    try {
      var fragment = window.nhlGalleryInviteFragment;
      delete window.nhlGalleryInviteFragment;
      var data;
      if (fragment && window.crypto && window.crypto.subtle) {
        var parts = fragment.split('.');
        if (parts.length !== 4 || parts[0] !== 'v1') return;
        var key = await window.crypto.subtle.importKey('raw', decode(parts[1]), 'AES-GCM', false, ['decrypt']);
        var bytes = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv: decode(parts[2]), additionalData: new TextEncoder().encode(id.toLowerCase()) }, key, decode(parts[3]));
        data = JSON.parse(new TextDecoder().decode(bytes));
        if (valid(data, id)) { try { sessionStorage.setItem(contactKey + id.toLowerCase(), JSON.stringify(data)); } catch (_) {} }
      } else data = JSON.parse(sessionStorage.getItem(contactKey + id.toLowerCase()) || 'null');
      if (valid(data, id)) apply(data);
    } catch (_) {
      var status = form && form.querySelector('[data-shortlist-prefill]');
      if (status) status.textContent = 'Enter your name and email below to send your shortlist.';
    }
  }
  function start() {
    forms.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      prepare(form);
      form.addEventListener('input', function (event) { if (event.target.name === 'contact[name]' || event.target.name === 'contact[email]') prepare(form); });
    });
    document.querySelectorAll('[data-pg-invite-link]').forEach(function (link) {
      try { var id = new URL(link.href).searchParams.get('gallery_ref'); if (idPattern.test(id || '')) link.href = window.nhlGalleryInviteURL(id); } catch (_) {}
    });
    prefill();
  }
  // One bounded delay before native serialization. Existing attribution/lead handlers
  // receive only the resumed submit, so this does not create another conversion event.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || forms.indexOf(form.id) === -1 || form.__nhlInviteResuming) return;
    var work = prepare(form);
    if (!work || typeof form.requestSubmit !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.__nhlInvitePreparing) return;
    form.__nhlInvitePreparing = true;
    var submitter = event.submitter;
    Promise.race([work, new Promise(function (resolve) { setTimeout(resolve, 750); })]).finally(function () {
      // A settled invite promise can run before the original submit algorithm
      // clears its re-entry guard. Resume in a new task, not its microtask checkpoint.
      setTimeout(function () {
        form.__nhlInviteResuming = true;
        try { form.requestSubmit(submitter || undefined); } finally { form.__nhlInviteResuming = false; form.__nhlInvitePreparing = false; }
      }, 0);
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
